import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Table from 'src/ui/library/Table';
import TableFilter from 'src/ui/library/TableFilter';
import { FastFilter } from 'src/ui/library/FastFilter';
import axios from 'axios';
import deepOmit from 'src/helpers/deepOmit';
import { createTableRows } from 'src/helpers';
import Spinner from 'src/ui/library/Spinner/Spinner';
import HistoryDisplayContainer from 'src/ui/library/HistoryDisplay';
import Grid from '@material-ui/core/Grid';
import { TABLE_STATUS } from 'src/constants/constants';
import debounce from 'lodash.debounce';
import { DOCUMENTS_URL } from 'src/constants/constants';
import intl from 'react-intl-universal';
import Dropdown from 'src/ui/library/Dropdown';
import _ from 'lodash';
import { DATA_TYPE } from '../../../../constants/constants';
import { saveCaseDataCollectQuestionnairePage } from 'src/services/questionnaire.service.js';
import { FormControlLabel, Switch, InputLabel } from '@material-ui/core';
import BadgeWithCloseButton from '../../../../new-ui/library/BadgeWithCloseButton/BadgeWithCloseButton';
import { DEFAULT_DASHBOARD_VIEW, DEFAULT_SESSION_KEY } from '../../../../constants/constants';
import { fnShowNewDashboard, fnSetIsAllDataFlag, fnGetDashboardView, getDashboardURL } from 'src/helpers/commonFunctions';
import { saveTaskDocument } from 'src/services/tasks.service.js';
import Checkbox from 'src/ui/library/Checkbox';

const CancelToken = axios.CancelToken;

/*
 * This component is an extension of the Table component. It allows you to quickly create
 * a table landing page.
 *
 */

class TableLanding extends React.Component {
  static propTypes = {
    /** Classname to be applied to <TableLanding> */
    className: PropTypes.string,
    /** Data that will be used to generate table columns */
    columns: PropTypes.PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        displayText: PropTypes.string.isRequired,
        visible: PropTypes.bool,
        sticky: PropTypes.bool,
        sortable: PropTypes.bool,
        renderComponent: PropTypes.function, // allows for custom cell rendering
        customSort: PropTypes.function,
      }),
    ).isRequired,
    /** If provided, the total number of rows per page */
    rowsPerPage: PropTypes.number.isRequired,
    /** Filters config provided to <FastFilter /> */
    fastFilter: PropTypes.shape({
      filters: PropTypes.func,
      render: PropTypes.func,
    }),
    dropDownFilter: PropTypes.shape({
      filters: PropTypes.func,
      render: PropTypes.func,
    }),
    /** Filters config provided to <TableFilter /> */
    gridFilter: PropTypes.shape({
      hideFilterButton: PropTypes.bool,
      hideSearch: PropTypes.bool,
      filters: PropTypes.func,
      render: PropTypes.func,
    }),
    /** History used to power navigation */
    history: PropTypes.object.isRequired,
    /** Default filters values used for FastFilter and Filter */
    defaultFilterValues: PropTypes.object,
    /**
     * Read Only mode will force table to ignore renderComponent per columns and display cell value.
     * It will also make rows not selectable.
     */
    readOnly: PropTypes.bool,
    /** Hide <Table /> header */
    hideTableHeader: PropTypes.bool,
    /** Hide landing back header back button container */
    hideLandingHeader: PropTypes.bool,
    /** Hide filter chips */
    hideFilterChips: PropTypes.bool,
    /** Enable/disable table pagination */
    pagination: PropTypes.bool,
    /** Populate first column with selectable radio button */
    selectableRows: PropTypes.bool,
    /** Provide custom footer to display with the Table */
    footer: PropTypes.func,
    /** Callback function to get reference to internal methods */
    tableActions: PropTypes.func,
    /**
     * Callback function for table updates. fn(actionType: string, tableState: object)
     * tableState enum: ('rowClick', 'cellClick', 'pageChange', 'colSort', 'rowsSelected', 'rowsDeleted', 'rowAdded')
     */
    onTableChange: PropTypes.func,
    /** Callback function used to populate table data in serverSide mode */
    onRequestData: PropTypes.func.isRequired,
    /** Callback function used to populate table filters in serverSide mode */
    onRequestFilters: PropTypes.func,
    /** Callback function used to modify payload */
    onModifyRequest: PropTypes.func,
    /** Callback function used to modify cascade filters */
    onChange: PropTypes.func,
    /** Callback function used to modify response from onRequestData() */
    onModifyResponse: PropTypes.func,
    /** Message for when no table data available */
    noTableDataMsg: PropTypes.string,
    /** Related Entity flag */
    isRelatedEntity: PropTypes.bool,
    /** To check if it is calling from documents page */
    isFromDocuments: PropTypes.bool,
    defaultFilterVisibility: PropTypes.bool,
    showCheckbox: PropTypes.bool,
    isPageMandatory: PropTypes.bool,
    handleparentanyCellSelected: PropTypes.func,
    isTaskDocument: PropTypes.bool,
    setCheckboxChecked: PropTypes.func,
    onDelete: PropTypes.func,
    setCheckboxUpdated: PropTypes.func,
    isDocument: PropTypes.bool,
  };

  static defaultProps = {
    rowsPerPage: 15, // Do not change this. For some reason the sticky columns have rendering issues when more than 15 in Edge/IE
    fastFilter: undefined,
    dropDownFilter: undefined,
    toggleFilter: undefined,
    gridFilter: undefined,
    sortColumn: undefined,
    sortDirection: undefined,
    hideTableHeader: false,
    hideLandingHeader: false,
    hideFilterChips: false,
    defaultFilterValues: {},
    className: '',
    isFromDocuments: false,
    isPageMandatory: false,
    isDocument: false,
    // pageData: []
  };

  state = {
    rows: [],
    columns: this.props.columns,
    filters: this.props.defaultFilterValues,
    fastFilter: {},
    dropDownFilter: {},
    toggleFilter: {},
    searchText: '',
    sortDirection: this.props.sortDirection || null,
    sortColumn: this.props.sortColumn || null,
    filter: true,
    totalRows: 0,
    payload: {
      pageNumber: 1,
      filter: true,
      pageSize: this.props.rowsPerPage,
      sortDirection: this.props.sortDirection,
      sortColumn: this.props.sortColumn,
      ...this.props.defaultFilterValues,
    },
    filtersDataResponse: null,
    tableDataResponse: null,
    isRelatedEntity: false,
    selected: true,
    selectedTask: '',
    isTaskFilter: false,
    // isFilterVisible: this.props.isFromDocuments ? false : true,
    isFilterVisible: false,
    notApplicable: this.props.pageData ? this.props.pageData.notApplicable : false,
    notSure: this.props.pageData ? this.props.pageData.unSure : false,
    pageData: this.props.pageData,
    anyCellSelected: false,
    pillFilter: {},
    rowTableData: null,
    isCasePillFilterRemoved: false,
    isFilterLoaded: false,
    selectedCaseId: null,
    isCaseSelectedFromGrid: false,
    resetPageToZero: false,
    refreshTable: false,
    isDownloadClicked: false,
  };

  constructor(props) {
    super(props);
    this.cancelTokenFn = null;
    this.debouncedSearch = debounce(this.getTableData, 150);
    this.setTableStatus = () => {};
    this.isComponentMounted = true;
    this.tableFilterRef = React.createRef();
  }
  componentDidMount() {
    const dashboardType = sessionStorage.getItem('dashboardType');
    if (dashboardType && this.props.taskType) {
      this.onDashboardType(dashboardType);
    }
    if (!this.props.documentCaseId) {
      setTimeout(() => {
        this.getTableData();
      }, 2000);
    } else {
      sessionStorage.setItem('document_filter_applied', false);
    }
    this.getFilterData();

    if (this.props.tableActions) {
      this.props.tableActions({
        fetchData: this.getTableData,
        fetchFilters: this.getFilterData,
        setTableState: this.setTableState,
      });
    }
    if (this.props.onLoadToggleSelectedValue && this.props.RToggle && this.props.LToggle) {
      this.setState({ selected: this.props.onLoadToggleSelectedValue.toLowerCase() === this.props.RToggle.toLowerCase() });
    }
  }

  componentWillUnmount() {
    this.isComponentMounted = false;
    if (this.cancelTokenFn !== null) {
      this.cancelTokenFn();
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.state.isDownloadClicked) {
      if (prevProps.defaultFilterValues !== this.props.defaultFilterValues) {
        this.setState(
          prevState => ({
            filters: { ...prevState.filters, ...this.props.defaultFilterValues },
            payload: { ...prevState.payload, ...this.props.defaultFilterValues, pageNumber: 1 },
            isTaskFilter: this.state.isTaskFilter,
          }),
          () => {
            this.getTableData();
          },
        );
      }
    }
  }

  setDownloadClickedTrue = async () => {
    await this.setState({ isDownloadClicked: true });
  };

  setDownloadClickedFalse = async () => {
    await this.setState({ isDownloadClicked: false });
  };
  showDocumentDownloadLoader = async () => {
    await this.setTableStatus(TABLE_STATUS.loading);
  };

  hideDocumentDownloadLoader = async () => {
    await this.setTableStatus(TABLE_STATUS.ready);
  };

  getTableData = isFilterApplied => {
    const { onRequestData, onModifyRequest, onModifyResponse, isRelatedEntity, isTaskDocument } = this.props;
    let { columns, refreshTable } = this.state;
    if (isTaskDocument && !refreshTable) {
      this.setState({ refreshTable: true });
      return;
    }
    this.resetPage();
    const payload = onModifyRequest ? onModifyRequest(this.state.payload, this.state) : this.state.payload;

    if (
      !isTaskDocument &&
      payload.caseId !== null &&
      typeof payload.caseId === 'string' &&
      this.getIsCasePillFilterRemoved() &&
      !this.getIsCaseSelectedFromGrid()
    )
      payload.caseId = null;

    if (
      !onRequestData ||
      !this.isComponentMounted ||
      (this.props.documentCaseId && sessionStorage.getItem('document_filter_applied') === 'false' && !isFilterApplied)
    ) {
      return;
    }

    if (this.cancelTokenFn !== null) {
      this.cancelTokenFn();
    }

    this.setTableStatus(TABLE_STATUS.loading);
    this.setState({ resetPageToZero: false });

    onRequestData(payload, { cancelToken: new CancelToken(c => (this.cancelTokenFn = c)) }).then(response => {
      if (!response) {
        return;
      }
      const responseData = onModifyResponse ? onModifyResponse(response) : response;

      if (typeof responseData.rows === 'undefined') {
        throw new Error('onRequestData expected API response to contain `rows`');
      }

      let rows = [];

      if (isRelatedEntity) {
        this.props.getEntityName(responseData.entityName);

        rows = responseData.rows;
        columns = responseData.columns;
      } else {
        rows = createTableRows(columns, responseData.rows);
      }

      this.setState(
        {
          tableDataResponse: responseData,
          notApplicable: this.props.isTaskDocument ? responseData.notApplicable : this.state.notApplicable,
          notSure: this.props.isTaskDocument ? responseData.unSure : this.state.notSure,
          rowTableData: responseData.rows,
          totalRows: responseData.total,
          rows,
          columns,
        },
        () => this.setTableStatus(TABLE_STATUS.ready),
      );
      if (this.props.isTaskDocument && this.props.filterCheckBoxChecked === null) {
        this.props.setCheckboxFilter(responseData.unSure || responseData.notApplicable);
        this.setState({ refreshTable: false });
      }
      sessionStorage.removeItem('document_filter_applied');
    });
  };

  getFilterData = () => {
    const { onRequestFilters } = this.props;

    if (!onRequestFilters || !this.isComponentMounted) {
      return;
    }

    onRequestFilters({ SelectedCaseId: this.props.documentCaseId ? this.props.documentCaseId : '' }).then(response => {
      if (!response) {
        return;
      }
      response.documentTypes && response.documentTypes.sort((f1, f2) => f1.name.localeCompare(f2.name));
      this.setState({ filtersDataResponse: response }, () => {
        this.setState({ isFilterLoaded: true });
      });
    });
  };

  handleFilterChange = (a, b) => {
    const { onChange } = this.props;
    if (a === 'hostCountry' && onChange) {
      onChange(b.hostCountry).then(response => {
        const updatedFilters = Object.assign(this.state.filtersDataResponse);
        updatedFilters.filters.applicationTypes = response;
        this.setState({ filtersDataResponse: updatedFilters });
      });
    }
  };

  getFastFilterComponent = ({ filters, render }) => {
    const filterConfig = filters(this.state.tableDataResponse);

    const FastFilterComponent = (
      <FastFilter filters={filterConfig} history={this.props.history} trackClickAnalytics={() => {}} onChange={this.handleFastFilter} />
    );

    if (render) {
      return render(FastFilterComponent);
    }

    return FastFilterComponent;
  };

  onDashboardType = value => {
    this.props.setDashboardType(value);
  };

  getDropDownComponent = ({ filters, render }, taskType) => {
    const filterConfig = filters(this.state.tableDataResponse);
    const dashboardType = sessionStorage.getItem('dashboardType');
    let type = taskType;
    if (dashboardType) {
      type = dashboardType === 'allData' ? DATA_TYPE.ALL_DATA : DATA_TYPE.MY_DATA;
    }
    const dropDownOptions = filterConfig.map(filter => ({ value: filter.id, label: filter.label }));
    const selectedOption = this.state.selectedTask === '' ? _.find(dropDownOptions, e => e.label === type).value : this.state.selectedTask;
    const FastFilterComponent = (
      <Dropdown
        className="action-dropdown"
        label="View"
        value={selectedOption}
        onChange={data => this.handleDropDownFilter(data.target.value)}
        options={dropDownOptions}
      />
    );

    if (render) {
      return render(FastFilterComponent);
    }

    return FastFilterComponent;
  };

  getPillComponent = () => {
    let PillComponent = [];
    if (this.state.pillFilter) {
      for (let [key, value] of Object.entries(this.state.pillFilter)) {
        let displayText = '';

        switch (key) {
          case 'documentCountry': {
            const country = this.state.filtersDataResponse.countries;
            value = _.find(country, e => e.id === value).name;
            displayText = 'Document Country';
            break;
          }
          case 'employee': {
            const emp = this.state.filtersDataResponse.employees;
            value = _.find(emp, e => e.id === value).name;
            displayText = 'Employee';
            break;
          }
          case 'employeeId': {
            const emp = this.state.filtersDataResponse.employeeList;
            value = _.find(emp, e => e.employeeId === value).employeeName;
            displayText = 'Employee';
            break;
          }
          case 'policyId': {
            const emp = this.state.filtersDataResponse.policyList;
            value = _.find(emp, e => e.policyId === value).policyName;
            displayText = 'Policy';
            break;
          }
          case 'homeCountryId': {
            const emp = this.state.filtersDataResponse.countryList;
            value = _.find(emp, e => e.countryId === value).countryName;
            displayText = 'Home Country';
            break;
          }
          case 'hostCountryId': {
            const emp = this.state.filtersDataResponse.countryList;
            value = _.find(emp, e => e.countryId === value).countryName;
            displayText = 'Host Country';
            break;
          }
          case 'documentSubType': {
            const docSubType = this.state.filtersDataResponse.documentSubTypes;
            value = _.find(docSubType, e => e.id === value).name;
            displayText = 'Document Sub-type';
            break;
          }
          case 'caseId': {
            const caseNumber = this.state.filtersDataResponse.caseNumber;
            const modelObj = _.find(caseNumber, e => e.id === value);
            value = modelObj ? modelObj.name : '';
            displayText = 'Case Number';
            break;
          }
          case 'documentType': {
            displayText = 'Document Type';
            break;
          }
          case 'expirationDateFrom': {
            displayText = 'Expiration Date From';
            break;
          }
          case 'expirationDateTo': {
            displayText = 'Expiration Date To';
            break;
          }
          case 'startdateFrom':
          case 'dateStartedFrom': {
            displayText = 'Start Date From';
            break;
          }
          case 'startdateTo':
          case 'dateStartedTo': {
            displayText = 'Start Date To';
            break;
          }
          case 'dateCreatedFrom': {
            displayText = 'Created Date From';
            break;
          }
          case 'dateCreatedTo': {
            displayText = 'Created Date To';
            break;
          }
          case 'uploadedDateFrom': {
            displayText = 'Upload Date From';
            break;
          }
          case 'uploadedDateTo': {
            displayText = 'Upload Date To';
            break;
          }
          default: {
          }
        }

        PillComponent.push(
          <BadgeWithCloseButton labelLeft={key} labelRight={value} displayText={displayText} onClickTest={this.handlePillClick} />,
        );
      }

      if (this.state.filters.IsExpiringIn90Days && this.props.is90DaysEnabled) {
        PillComponent.push(
          <BadgeWithCloseButton
            labelLeft={'Expirationdate'}
            labelRight={this.props.expirationsDate}
            displayText={'Expiration date'}
            onClickTest={this.props.doc90DaysStateHandler}
          />,
        );
      }
      return PillComponent;
    }
  };

  handlePillFilterOnClick = (removeFromFilter, removeFromPill, removeFromPayload, key) => {
    return Promise.resolve(
      this.setState(
        prevState => ({
          filters: removeFromFilter,
          pillFilter: removeFromPill,
          // payload: removeFromPayload,
          payload: { ...removeFromPayload, pageNumber: 1 },
          filter: true,
          isTaskFilter: true,
        }),
        async () => {
          await this.resetPage();
          await this.getTableData();
        },
      ),
    ).then(() => {
      if (this.tableFilterRef && this.tableFilterRef.current && key === 'caseId') {
        this.tableFilterRef.current.clearDefaultCaseId();
      }
    });
  };

  handlePillClick = key => {
    let removeFromFilter = this.state.filters;
    let removeFromPill = this.state.pillFilter;
    let removeFromPayload = this.state.payload;
    delete removeFromFilter[key];
    delete removeFromPill[key];
    delete removeFromPayload[key];
    if (key === 'caseId') {
      this.setState({ isCasePillFilterRemoved: true });
      this.setState({ selectedCaseId: null });
      this.setState({ isCaseSelectedFromGrid: false });
    }
    this.handlePillFilterOnClick(removeFromFilter, removeFromPill, removeFromPayload, key);
  };

  getIsCasePillFilterRemoved = () => {
    return this.state.isCasePillFilterRemoved;
  };

  getIsCaseSelectedFromGrid = () => {
    return this.state.isCaseSelectedFromGrid;
  };

  getCaseId = () => {
    return this.state.selectedCaseId;
  };

  resetPage = () => {
    this.setState({ resetPageToZero: true });
  };

  getToggleFilterComponent = ({ filters, render }, LToggle, RToggle, switchStyles) => {
    const FastFilterComponent = (
      <Grid container>
        <Grid item className="toggle-switch" style={{ color: 'black', display: 'flex' }}>
          <FormControlLabel
            control={
              <Switch
                id="isAllData"
                className={switchStyles.switch}
                checked={this.state.selected}
                onChange={data => this.handleToggleFilter(this.state.selected ? 'isAllData' : 'allData')}
                inputProps={{ 'aria-label': 'secondary checkbox' }}
              />
            }
            label={LToggle}
            labelPlacement="start"
          />
          <InputLabel style={{ color: 'black', padding: '12px' }}>{RToggle}</InputLabel>
        </Grid>
      </Grid>
    );
    if (render) {
      return render(FastFilterComponent);
    }
    return FastFilterComponent;
  };

  saveDatCollectPageDetails = async stateData => {
    if (!this.props.isTaskDocument) {
      //padma start
      const { organizerInstanceId, entityId, yearTypeId, organizerTypeId, pageId, sourceTableId } = this.props.pageData;
      const pageState = true;
      const orgOptions = {
        entityId,
        organizerInstanceId,
        organizerTypeId,
        yearTypeId,
        pageId,
        pageSourceId: sourceTableId,
        languageId: 1,
        pageState,
        isSubmitted: false,
        dataRequests: [],
        tables: [],
        updateOnlyCheckBoxValue: true,
        notApplicable: stateData.notApplicable,
        unSure: stateData.notSure,
        multilineEntities: [],
      };

      try {
        await saveCaseDataCollectQuestionnairePage(orgOptions).catch(e => {
          this.props.toggleSpinner(false);
          throw e;
        });
      } catch (e) {
        this.props.toggleSpinner(false);
        throw e;
      }
      //padma end
    } else {
      const payload = {
        TaskId: this.props.defaultFilterValues.RequiredActionId,
        CaseId: this.props.defaultFilterValues.caseId,
        ProceedCompleteTask: false,
        NotApplicable: stateData.notApplicable,
        UnSure: stateData.notSure,
        Documents: [],
      };
      try {
        await saveTaskDocument(payload).catch(e => {
          this.props.toggleSpinner(false);
          throw e;
        });
      } catch (e) {
        this.props.toggleSpinner(false);
        throw e;
      }
    }
  };

  resetNotApplicable = () => {
    let newView = fnGetDashboardView();
    this.setState(
      prevState => ({
        notApplicable: !prevState.notApplicable,
        notSure: prevState.notSure === true ? false : prevState.notSure,
      }),
      () => {
        if (this.props.isTaskDocument && newView) {
          this.props.setCheckboxChecked(this.state.notApplicable);
        }
        if (this.props.setCheckboxChecked) {
          if (this.props.setCheckboxUpdated) {
            this.props.setCheckboxUpdated(true);
          }
          this.props.setCheckboxChecked(this.state.notApplicable);
        }
        if (this.props.setCheckboxFilter) {
          this.props.setCheckboxFilter(this.state.notApplicable);
          this.setState({ refreshTable: false });
        }
        this.saveDatCollectPageDetails(this.state);
      },
    );
  };
  resetNotSure = () => {
    let newView = fnGetDashboardView();
    this.setState(
      prevState => ({
        notSure: !prevState.notSure,
        notApplicable: prevState.notApplicable === true ? false : prevState.notApplicable,
      }),
      () => {
        if (this.props.isTaskDocument && newView) {
          this.props.setCheckboxChecked(this.state.notSure);
        }
        if (this.props.setCheckboxChecked) {
          if (this.props.setCheckboxUpdated) {
            this.props.setCheckboxUpdated(true);
          }
          this.props.setCheckboxChecked(this.state.notSure);
        }
        if (this.props.setCheckboxFilter) {
          this.props.setCheckboxFilter(this.state.notSure);
          this.setState({ refreshTable: false });
        }
        this.saveDatCollectPageDetails(this.state);
      },
    );
  };

  getPageType = () => {
    return this.props.history &&
      (this.props.history.location.pathname.includes(DOCUMENTS_URL) || this.props.history.location.pathname.includes('/cases/detail/'))
      ? 'document'
      : '';
  };

  getGridFilterComponent = ({ filters, render, hideFilterButton = false, hideSearch = false }) => {
    const { filtersDataResponse, notApplicable, notSure, pageData, anyCellSelected } = this.state;
    const { onRequestFilters, showCheckbox, isPageMandatory, isTaskSubmitted } = this.props;

    if (onRequestFilters && !filtersDataResponse) {
      return null;
    }

    const noFilters = !onRequestFilters && hideFilterButton;

    const GridFilterComponent = (
      <TableFilter
        ref={this.tableFilterRef}
        filters={noFilters ? [] : filters(this.state.filtersDataResponse)}
        onSearch={this.handleFilterSearch}
        onApply={this.handleFilterApply}
        onClear={this.handleFilterClear}
        showFilter={!hideFilterButton}
        showSearch={!hideSearch}
        onChange={this.handleFilterChange}
        pageType={this.getPageType()}
        onFilter={this.handleFilterVisibility}
        isShowFilterOptions={this.state.isFilterVisible}
        resetNotApplicable={this.resetNotApplicable}
        resetNotSure={this.resetNotSure}
        notApplicable={notApplicable}
        notSure={notSure}
        showCheckbox={showCheckbox}
        isPageMandatory={isPageMandatory}
        pageData={pageData}
        isTaskSubmitted={isTaskSubmitted}
        anyCellSelected={anyCellSelected}
        defaultSelectedFilters={this.props.defaultSelectedFilters}
        isFilterLoaded={this.state.isFilterLoaded}
        isRelatedEntity={this.props.isRelatedEntity || this.props.isDocument}
      />
    );

    if (render) {
      return render(GridFilterComponent);
    }

    return <div className="landing-gridfilter-container">{GridFilterComponent}</div>;
  };

  setTableState = (newState, cb = () => {}) => {
    if (!this.isComponentMounted) {
      return;
    }

    const { filters } = newState;
    let modifiedPayload = {};

    if (filters) {
      modifiedPayload = { ...filters, ...modifiedPayload };
    }

    this.setState(
      prevState => ({ ...newState, payload: { ...prevState.payload, pageNumber: 1, ...modifiedPayload } }),
      () => cb(),
    );
  };
  handleparentanyCellSelected = anyCellSelected => {
    this.setState({ anyCellSelected: anyCellSelected });
  };
  onTableChange = (actionType, data) => {
    if (this.props.onTableChange) {
      this.props.onTableChange(actionType, data, { setTableState: this.setTableState, fetchData: this.getTableData });
    }

    switch (actionType) {
      case 'changeSort':
        const {
          sortedBy: { id, sortDirection },
        } = data;

        this.setState(
          prevState => ({
            sortDirection,
            sortColumn: id,
            payload: { ...prevState.payload, sortDirection, sortColumn: id, filter: true },
          }),
          () => this.getTableData(),
        );
        break;

      case 'changePage':
        const {
          state: { page },
        } = data;

        this.setState(
          prevState => ({ payload: { ...prevState.payload, pageNumber: page + 1 } }),
          () => this.getTableData(),
        );
        break;

      default:
        break;
    }
  };

  handleFilterSearch = searchText => {
    this.setState(
      prevState => ({ searchText, isTaskFilter: true, payload: { ...prevState.payload, searchText, filter: true, pageNumber: 1 } }),
      () => this.debouncedSearch(),
      this.resetPage(),
    );
  };

  handleFilterApply = filters => {
    const __fnGetfilterDetails = (filter, prevState) => {
      if (fnShowNewDashboard()) {
        if (prevState && prevState['Expirationdate'] && !filter['Expirationdate']) {
          return { ...filter, Expirationdate: prevState['Expirationdate'] };
        }
      }
      return filter;
    };

    this.setState(
      prevState => ({
        filters: deepOmit(prevState.filters, Object.keys(filters)),
        payload: { ...prevState.payload, pageNumber: 1, ...filters },
        filter: true,
        isTaskFilter: true,
        pillFilter: __fnGetfilterDetails(filters, prevState.pillFilter),
      }),
      async () => {
        await this.setState({ selectedCaseId: this.state.payload.caseId });
        if (this.state.payload.caseId !== null && typeof this.state.payload.caseId === 'string')
          this.setState({ isCaseSelectedFromGrid: true });
        await this.resetPage();
        await this.getTableData(true);
      },
    );
  };

  handleFilterVisibility = () => {
    // if (this.props.isFromDocuments) {
    this.setState(prevState => ({
      isFilterVisible: !this.state.isFilterVisible,
    }));
    // }
  };

  handleFilterClear = filters => {
    this.setState(
      prevState => ({
        filters: deepOmit(prevState.filters, Object.keys(filters)),
        payload: deepOmit(prevState.payload, Object.keys(filters)),
        filter: false,
        isTaskFilter: false,
        pillFilter: {},
      }),
      async () => {
        this.setState({ isCasePillFilterRemoved: true });
        this.setState({ selectedCaseId: null });
        this.setState({ isCaseSelectedFromGrid: false });
        this.setState(prevState => ({ payload: { ...prevState.payload, pageNumber: 1 } }));
        if (this.props.is90DaysEnabled) {
          await this.props.doc90DaysStateHandler();
        }
        await this.resetPage();
        await this.getTableData();
      },
    );
  };

  onFilterClear = async () => {
    if (this.tableFilterRef && this.tableFilterRef.current) {
      await this.tableFilterRef.current.handleClear();
    }
  };

  handleFastFilter = filters => {
    this.onTableChange('fastFilter', filters);
  };
  handleToggleFilter = filters => {
    switch (filters) {
      case 'isAllData':
        this.setState({ selected: false });
        this.setState(prevState => ({
          payload: { ...prevState.payload, isAllData: false },
        }));
        fnSetIsAllDataFlag(false);
        break;
      case 'allData':
        this.setState({ selected: true });
        this.setState(prevState => ({
          payload: { ...prevState.payload, isAllData: true },
        }));
        fnSetIsAllDataFlag(true);
        break;
      default:
        break;
    }
    this.resetPage();
    this.onTableChange('fastFilter', { [filters]: true });
  };
  handleDropDownFilter = filters => {
    this.setState({ selectedTask: filters });
    switch (filters) {
      case 'myCase':
        this.setState(prevState => ({
          payload: { ...prevState.payload, viewType: filters },
        }));
        this.onDashboardType('myData');
        break;
      case 'teamCase':
        this.setState(prevState => ({
          payload: { ...prevState.payload, viewType: filters },
        }));
        this.onDashboardType('allData');
        break;
      case 'My Tasks':
        this.setState(prevState => ({
          payload: { ...prevState.payload, taskFilter: 1 },
        }));
        this.onDashboardType('myData');
        break;
      case 'Team Tasks':
        this.setState(prevState => ({
          payload: { ...prevState.payload, taskFilter: 2 },
        }));
        this.onDashboardType('allData');
        break;
      default:
        break;
    }
    this.onTableChange('fastFilter', { [filters]: true });
  };

  getLoaderInCaseOfDefaultLoad(tableDataResponse) {
    return (
      !tableDataResponse &&
      this.props.documentCaseId &&
      sessionStorage.getItem('document_filter_applied') === 'false' && (
        <div style={{ margin: 'auto' }} className="table-landing-spinner">
          <Spinner size={70} />
        </div>
      )
    );
  }

  render() {
    const {
      readOnly,
      addRowLabel,
      className,
      onRequestFilters,
      onRequestData,
      onTableChange,
      gridFilter,
      pillView,
      fastFilter,
      dropDownFilter,
      toggleFilter,
      taskType,
      LToggle,
      RToggle,
      hideLandingHeader,
      isFromDocuments,
      showCheckbox,
      isTaskDocument,
      switchStyles,
      defaultFilterValues,
      setCheckboxChecked,
      setCheckboxUpdated,
      isPageMandatory,
      onDelete,
      isTaskSubmitted,
      ...otherProps
    } = this.props;

    const { tableDataResponse, rowTableData, anyCellSelected } = this.state;

    let { rows, columns, totalRows, notApplicable, notSure, pageData } = this.state;
    if (!this.props.documentCaseId && !tableDataResponse) {
      return (
        <div style={{ margin: 'auto' }} className="table-landing-spinner">
          <Spinner size={70} />
        </div>
      );
    }

    let default_view = sessionStorage.getItem(DEFAULT_SESSION_KEY);
    let isDefaultOldView =
      default_view === null
        ? (process.env.SHOW_DEFAULT_OLD_VIEW_ENV || 'false').toLowerCase() === 'true'
        : default_view.toLowerCase() === DEFAULT_DASHBOARD_VIEW.EXISTING.toLowerCase();

    return (
      <React.Fragment>
        <div className={classNames('landing-table-container', className)}>
          {!hideLandingHeader && (
            <div className="landing-fastfilter-container">
              <Grid container className="fastfilter">
                {isFromDocuments ? null : (
                  <Grid item className="fastfilter-back-btn" lg={1} md={1} sm={1} xs={1}>
                    <HistoryDisplayContainer backUrl={getDashboardURL()} history={this.props.history} trackClickAnalytics={() => {}} />
                  </Grid>
                )}
                {!isFromDocuments && this.props.history && this.props.history.location.pathname.includes(DOCUMENTS_URL) ? (
                  <p>{intl.get('documents.filters.selectFilterTxt')}</p>
                ) : this.props.history && this.props.history.location.pathname.includes(DOCUMENTS_URL) && this.props.isCorpClient ? (
                  <React.Fragment>
                    {!fastFilter && toggleFilter ? <Grid item lg={9} md={9} sm={9} xs={12}></Grid> : null}
                    {toggleFilter ? (
                      <Grid className="togglefiter" item>
                        {toggleFilter && tableDataResponse && this.getToggleFilterComponent(toggleFilter, LToggle, RToggle, switchStyles)}
                      </Grid>
                    ) : null}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {!fastFilter && toggleFilter ? <Grid item lg={9} md={9} sm={9} xs={12}></Grid> : null}
                    {isFromDocuments &&
                    this.props.history &&
                    !this.props.history.location.pathname.includes(DOCUMENTS_URL) &&
                    toggleFilter ? (
                      <Grid className="togglefiter">
                        {toggleFilter && tableDataResponse && this.getToggleFilterComponent(toggleFilter, LToggle, RToggle, switchStyles)}
                      </Grid>
                    ) : null}
                    {fastFilter ? (
                      <Grid item lg={9} md={9} sm={9} xs={12}>
                        {fastFilter && tableDataResponse && this.getFastFilterComponent(fastFilter)}
                      </Grid>
                    ) : null}
                    {!fastFilter && dropDownFilter ? <Grid item lg={9} md={9} sm={5} xs={3}></Grid> : null}
                    {dropDownFilter ? (
                      <Grid className="dropdownfiter" item lg={2} md={2} sm={2} xs={12}>
                        {dropDownFilter && tableDataResponse && this.getDropDownComponent(dropDownFilter, taskType)}
                      </Grid>
                    ) : null}
                  </React.Fragment>
                )}
              </Grid>
            </div>
          )}
          {gridFilter && this.getGridFilterComponent(gridFilter)}
          {isDefaultOldView ? (
            this.props.history &&
            this.props.history.location.pathname.includes(DOCUMENTS_URL) && (
              <p className="max-document-text">{intl.get('documents.filters.maxRecordText')}</p>
            )
          ) : (
            <Grid container direct="row" className="pill-container">
              <Grid item xs={8}>
                {/* <div style={{display: 'flex'}}>{this.getPillComponent()}</div> */}
                {this.getPillComponent()}
              </Grid>
              <Grid item xs={4} className="align-self-center text-align-end">
                {this.props.history && this.props.history.location.pathname.includes(DOCUMENTS_URL) && (
                  <p className="max-document-text">{intl.get('documents.filters.maxRecordText')}</p>
                )}
              </Grid>
            </Grid>
          )}
          {showCheckbox && (
            <div className="checkbox-title">
              Select the checkbox next to each record to attach to this case. If no record is selected indicate the reason below:
            </div>
          )}
          {showCheckbox && (
            <div className="checkbox-container">
              {!isPageMandatory && (
                <Checkbox
                  checked={notApplicable}
                  defaultChecked={notApplicable}
                  disabled={notSure || anyCellSelected || isTaskSubmitted || (pageData && pageData.isSubmitted)}
                  key={'Checkbox1'}
                  label={'Not Applicable'}
                  onChange={() => this.resetNotApplicable()}
                />
              )}
              <Checkbox
                checked={notSure}
                defaultChecked={notSure}
                disabled={notApplicable || anyCellSelected || isTaskSubmitted || (pageData && pageData.isSubmitted)}
                key={'Checkbox2'}
                //label={'Unsure what to select'}
                label={"I'm not sure (EY may contact you for more information)"}
                onChange={() => this.resetNotSure()}
              />
            </div>
          )}

          {this.getLoaderInCaseOfDefaultLoad(tableDataResponse)}

          {tableDataResponse && (
            <div className="landing-table">
              <Table
                styleType={'landingPage'}
                serverSide={true}
                columns={columns}
                rows={rows}
                totalRows={totalRows}
                rowTableData={rowTableData}
                requestData={tableDataResponse}
                onTableChange={this.onTableChange}
                setTableStatus={fn => (this.setTableStatus = fn)}
                showCheckbox={showCheckbox}
                notApplicable={notApplicable}
                notSure={notSure}
                pageData={pageData}
                isTaskDocument={isTaskDocument}
                isTaskSubmitted={isTaskSubmitted}
                defaultFilterValues={defaultFilterValues}
                handleparentanyCellSelected={this.handleparentanyCellSelected}
                setCheckboxChecked={setCheckboxChecked}
                setCheckboxUpdated={setCheckboxUpdated}
                isPageMandatory={isPageMandatory}
                onDelete={onDelete}
                tableHeadCellProps={{
                  scope: null,
                  role: null,
                }}
                resetPageToZero={this.state.resetPageToZero}
                {...otherProps}
              />
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default TableLanding;
